import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { AttributeContainer, CrossContainer, HeaderContainer, InputsContainer } from './styles';
import { Divider, TextField } from '@mui/material';
import { Close } from '@mui/icons-material';
import theme from '../../theme/theme';
import { RequestModal } from '../../components/RequestModal';
import { ContactFormProps } from './types';
import { useToasts } from "react-toast-notifications";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: 'auto',
    minWidth: '250px',
    maxHeight: '700px',
    overflow: 'auto',
    borderRadius: '20px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


const ContactForm: React.FC<ContactFormProps> = ({
    onClose
}) => {
    const { addToast } = useToasts();

    // ------------------- STATES -------------------
    const [open, setOpen] = React.useState(false);

    const [warningMessage, setWarningMessage] = React.useState("");
    const [isModified, setIsModified] = React.useState(false);
    const [invalid, setInvalid] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setWarningMessage('');
        setIsModified(false);
        setInvalid(false);
        setUserName('');
        setUserLastName('');
        setUserEmail('');
        setUserMessage('');
        onClose();
    };

    // ------------------- CONTACT FORM INFO -------------------
    const [userName, setUserName] = React.useState('');
    const [userLastName, setUserLastName] = React.useState('');
    const [userEmail, setUserEmail] = React.useState('');
    const [userMessage, setUserMessage] = React.useState('');

    // ------------------- USE EFFECT -------------------
    React.useEffect(() => {
        handleOpen();
    }, []);

    // ------------------- API REQUEST -------------------
    const sendMessage = async (event: any) => {
        event.preventDefault();

        if (userName === '' || userLastName === '' || userEmail === '' || userMessage === '') {
            addToast("Favor de llenar todos los campos", {
                appearance: "error",
                autoDismiss: true,
            });
            return;
        }

        const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail);
        if (!emailValidation) {
            addToast("El email no es válido", {
                appearance: "error",
                autoDismiss: true,
            });
            return;
        }

        // await postMessage(userName, userLastName, userEmail, userMessage)
        //     .then((res: any) => {
        //         if (res.status === 200) {
        //             addToast("Favor de verificar su correo", {
        //                 appearance: "success",
        //                 autoDismiss: true,
        //             });
        //         } else {
        //             addToast("¡Ocurrió un error!", {
        //                 appearance: "error",
        //                 autoDismiss: true,
        //             });
        //         }
        //     })
        //     .catch((err: any) => {
        //         addToast("¡Ocurrió un error!", {
        //             appearance: "error",
        //             autoDismiss: true,
        //         });
        //     });

        handleClose();
    }

    return (
        <>
            {
                isModified ? (
                    <RequestModal
                        title='¡Usuario modificado!'
                        description={warningMessage}
                        onClose={handleClose}
                    />
                ) : (
                    invalid &&
                    <RequestModal
                        title='Ocurrió un error'
                        description={warningMessage}
                        onClose={handleClose}
                    />
                )
            }
            <Modal
                open={open}
                // onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <>
                        <CrossContainer
                            onClick={handleClose}
                        >
                            <Close />
                        </CrossContainer>
                        <HeaderContainer>Contáctanos</HeaderContainer>
                        <InputsContainer>
                            <AttributeContainer>
                                <TextField
                                    label="Nombre(s)"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    sx={{ margin: "15px 0", width: '100%' }}
                                    InputProps={{
                                        style: {
                                            borderRadius: "14px",
                                        },
                                    }}
                                />
                            </AttributeContainer>
                            <AttributeContainer>
                                <TextField
                                    label="Apellido(s)"
                                    type="text"
                                    variant="outlined"
                                    required
                                    value={userLastName}
                                    onChange={(e) => setUserLastName(e.target.value)}
                                    fullWidth
                                    sx={{ margin: "15px 0", width: '100%' }}
                                    InputProps={{
                                        style: {
                                            borderRadius: "14px",
                                        },
                                    }}
                                />
                            </AttributeContainer>
                        </InputsContainer>
                        <InputsContainer>
                            <AttributeContainer>
                                <TextField
                                    label="Correo"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={userEmail}
                                    onChange={(e) => setUserEmail(e.target.value)}
                                    required
                                    sx={{ margin: "15px 0", width: '100%' }}
                                    InputProps={{
                                        style: {
                                            borderRadius: "14px",
                                        },
                                    }}
                                />
                            </AttributeContainer>
                        </InputsContainer>
                        <InputsContainer>
                            <AttributeContainer>
                                <TextField
                                    label="Mensaje"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    minRows={5}
                                    maxRows={10}
                                    value={userMessage}
                                    onChange={userMessage => setUserMessage(userMessage.target.value)}
                                    required
                                    sx={{ margin: "15px 0", width: '100%' }}
                                    InputProps={{
                                        style: {
                                            borderRadius: "14px",
                                        },
                                    }}
                                />
                            </AttributeContainer>
                        </InputsContainer>
                        <Divider />
                        <Button
                            variant="contained"
                            onClick={sendMessage}
                            sx={{
                                width: "100%",
                                marginTop: "20px",
                                borderRadius: "15px",
                                fontSize: "16px",
                                backgroundColor: theme.color.navy,
                                color: theme.color.white,
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: theme.color.space,
                                },
                            }}
                        >Enviar
                        </Button>
                    </>
                </Box>
            </Modal>
        </>
    )
}

export default ContactForm;